import { render, staticRenderFns } from "./received-order-input.vue?vue&type=template&id=6978861e&scoped=true&"
import script from "./received-order-input.vue?vue&type=script&lang=js&"
export * from "./received-order-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6978861e",
  null
  
)

export default component.exports